import { render, staticRenderFns } from "./approveSearch.vue?vue&type=template&id=0dd41566&scoped=true"
import script from "./approveSearch.vue?vue&type=script&lang=js"
export * from "./approveSearch.vue?vue&type=script&lang=js"
import style0 from "./approveSearch.vue?vue&type=style&index=0&id=0dd41566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd41566",
  null
  
)

export default component.exports